module.exports = __webpack_public_path__ + "img/logo_taf2.c89cb4f0.png";